import { render } from "./KeynoteSpeakersView.vue?vue&type=template&id=27fbdb2e&scoped=true"
const script = {}

import "./KeynoteSpeakersView.vue?vue&type=style&index=0&id=27fbdb2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fbdb2e"]])

export default __exports__